/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ExamApplicationDataType {
    Idle = 0,
    ConfirmationRunning = 1,
    ConfirmationClosed = 2,
    StudentReady = 3,
    PreEncounter = 4,
    Encounter = 5,
    PostEncounter = 6,
    Closing = 7,
}
